module.exports = __webpack_public_path__ + "static/loggedIn-7425648a12a66e903f614d6d1a5056bb.jpg";